jQuery(document).ready(function($) {

    function showQuantityCheckAlert($target) {
        const $alert = $(
            '<div class="qty-warning">Du försöker köpa fler än vad som finns i lager</div>');

        const targetOffsets = $target.offset();

        $('body').append($alert);

        const targetWidth = $target.innerWidth();
        const alertWidth = $alert.innerWidth();
        const alertHeight = $alert.innerHeight();

        $alert.css('top', targetOffsets.top - alertHeight - 15);
        $alert.css(
            'left',
            targetOffsets.left + (targetWidth / 2) - (alertWidth / 2),
        );

        $alert.fadeIn(200);

        setTimeout(function() {
            $alert.fadeOut(200, function() {
                $alert.remove();
            });
        }, 2000);
    }

    $(window).bind('load', function() {
        $('.quantity .qty').each(function() {
            if (parseInt($(this).val()) === parseInt($(this).attr('min'))) {
                $(this).prevAll('.minus').addClass('disabled');
            }

            if (parseInt($(this).val()) === 1) {
                $(this).prevAll('.minus').addClass('disabled');
            }

            if (parseInt($(this).val()) === parseInt($(this).attr('max'))) {
                $(this).nextAll('.plus').addClass('disabled');
            }
        });
    });

    // Only allow max value in qty input
    $(document).on('keydown keyup', '.quantity .qty', function(e) {
        if ($(this).hasClass('backorders-allowed')) {
            let stock = parseInt($(this).attr('stock'));
            let backorders = parseInt($(this).attr('backorder_limit'));

            let variation_input = $('.variation-qty');

            if (variation_input.length > 0) {
                stock = parseInt(variation_input.attr('stock'));
                backorders = parseInt(variation_input.attr('backorder_limit'));
            }

            let backorder_limit = stock - backorders;
            let input_val = parseInt($(this).val());

            if (backorders < 0) {
                if (input_val > backorder_limit
                    && e.keyCode !== 46
                    && e.keyCode !== 8
                ) {
                    $(this).val(backorder_limit);

                    showQuantityCheckAlert($(this));
                }
            }
        } else {
            let max = parseInt($(this).attr('max'));

            if (isNaN(max)) {
                $(this).prop('readonly', true);
            }

            let input_val = parseInt($(this).val());

            if (
                input_val > max &&
                e.keyCode !== 46 &&
                e.keyCode !== 8
            ) {
                $(this).val(max);

                showQuantityCheckAlert($(this));
            }
        }
    });

    $(document).on('mousedown', '.minus', function() {
        const $minus = $(this);
        const $qty = $minus.nextAll('.qty');
        const $plus = $qty.nextAll('.plus');

        const minQty = parseInt($qty.attr('min'));
        const qty = parseInt($qty.val()) - 1;

        $minus.addClass('active');

        $plus.prop('disabled', false).removeClass('disabled');

        if (minQty > 0 && (qty + 1 < 2 || qty + 1 === minQty)) {
            $minus.prop('disabled', true).addClass('disabled');
            return;
        } else {
            $minus.prop('disabled', false).removeClass('disabled');
        }

        let $cart_item = $minus.closest('.woocommerce-mini-cart-item');

        if ($cart_item.length) {
            let cartItemKey = $cart_item.data('cart_item_key');
            let quantity = qty;

            if (quantity < 1) {
                quantity = 1;
            }

            onMiniCartQuantityChange($cart_item, cartItemKey, quantity);
        }
    });

    $(document).on('mouseup', '.minus', function() {
        $(this).removeClass('active');
    });

    $(document).on('mousedown', '.plus', function() {
        $(this).addClass('active');

        const $input = $(this).prev();

        $(this)
            .prevAll('.minus')
            .prop('disabled', false)
            .removeClass('disabled');

        if (parseInt($(this).prevAll('.qty').val()) ===
            (parseInt($(this).prevAll('.qty').attr('max')) - 1)) {
            $(this).addClass('disabled');
        } else {
            $(this).removeClass('disabled');
        }

        if ($input.hasClass('backorders-allowed')) {
            let stock = parseInt($input.attr('stock'));
            let backorders = parseInt($input.attr('backorder_limit'));

            let variation_input = $('.variation-qty');

            if (variation_input.length > 0) {
                stock = parseInt(variation_input.attr('stock'));
                backorders = parseInt(variation_input.attr('backorder_limit'));
            }

            let backorder_limit = stock - backorders;
            let input_val = parseInt($input.val());

            if (backorders < 0) {
                if (input_val >= backorder_limit) {
                    $(this).prop('disabled', true);

                    showQuantityCheckAlert($input);
                    return;
                }
            }
        } else {
            let max = parseInt($input.attr('max'));
            let input_val = parseInt($input.val());

            if (input_val >= max) {
                $(this).prop('disabled', true);

                showQuantityCheckAlert($input);
                return;
            }
        }

        let $cart_item = $(this).closest('.woocommerce-mini-cart-item');

        if ($cart_item.length) {
            let cartItemKey = $cart_item.data('cart_item_key');
            let quantity = parseInt($cart_item.find('.qty').val()) + 1;

            onMiniCartQuantityChange($cart_item, cartItemKey, quantity);
        }
    });

    $(document).on('mouseup', '.plus', function() {
        $(this).removeClass('active');
    });

    function onMiniCartQuantityChange($cart_item, cartItemKey, quantity) {
        // This event is used by the MiniCart-component
        window.dispatchEvent(new CustomEvent(
            'quantity-changed',
            {
                detail: {
                    target: $cart_item,
                    cart_item_key: cartItemKey,
                    quantity: quantity,
                },
            },
        ));

    }

});
